<template>
    <div>
        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <h5 class="text-header">Tanda-Tanda Vital</h5>
                <b-row>
                    <b-col md="6" lg="6">
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label text-title">Tinggi Badan</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.tinggi_badan ? dataRM.anamnesa.tinggi_badan : '-' }} cm
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label text-title">Berat Badan</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.berat_badan ? dataRM.anamnesa.berat_badan : '-' }} kg
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label text-title">Suhu</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.suhu ? dataRM.anamnesa.suhu : '-' }} c
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label text-title">Sistole</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.tensi_sistole ? dataRM.anamnesa.tensi_sistole : '-' }} mmHg
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label text-title">Diastole</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.tensi_diastole ? dataRM.anamnesa.tensi_diastole : '-' }} mmHg
                            </div>
                        </div>
                    </b-col>
                    <b-col md="6" lg="6">
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label text-title">Nadi</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.nadi ? dataRM.anamnesa.nadi : '-' }} x/menit
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label text-title">Respirasi</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.respirasi ? dataRM.anamnesa.respirasi : '-' }} x/menit
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label text-title">Lingkar Perut</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.lingkar_perut ? dataRM.anamnesa.lingkar_perut : '-' }} cm
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label text-title">IMT</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.imt ? dataRM.anamnesa.imt : '-' }} kg/m2
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label text-title">Saturasi Oksigen</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.saturasi_oksigen ? dataRM.anamnesa.saturasi_oksigen : '-' }} %
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>
        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <h5>Pemeriksaan Fisik</h5>
                <b-row class="mt-5" v-show="kategoriPasien == 2">
                    <b-col lg="12" md="12">
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-3 col-form-label"> Kesadaran</label>
                            <div class="col-sm-9 form-control-plaintext">
                                <strong>{{
                                    dataRM.bpjs_nmSadar || "-"
                                }}</strong>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col lg="12" md="12">
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-3 col-form-label">Tingkat Kesadaran</label>
                            <div class="col-sm-9 form-control-plaintext">
                                <strong>{{
                                    dataRM.pemeriksaan_fisik.tingkat_kesadaran || "-"
                                }}</strong>
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <b-row class="mt-5">
                    <b-col lg="6" md="6">
                        <b-img v-if="drawPathFisik" v-bind:src="drawPathFisik" fluid></b-img>
                    </b-col>
                    <b-col lg="6" md="6" :style="`width: ${contentHalfWidth}px;`">
                        <div v-html="this.dataRM.pemeriksaan_fisik.notes"></div>
                    </b-col>
                </b-row>
            </div>
        </div>

        <div class="card card-box mb-3" v-if="poliGigi">
            <div class="card-body p-4">
                <h5 class="text-header">Odontogram</h5>
                <b-row class="mt-5">
                    <b-col lg="12" md="12">
                        <label for="kondisi-gigi" class="text-title">Pemeriksaan Extraoral</label>
                        <b-row class="pt-4">
                            <b-col cols="2" class="text-title">Muka</b-col>
                            <b-col cols="3">: {{ fieldOdonPemeriksaan.muka || '-' }}</b-col>
                            <b-col cols="2" class="text-title offset-1">Warna Kulit</b-col>
                            <b-col cols="3">: {{ fieldOdonPemeriksaan.warna_kulit || '-' }}</b-col>
                        </b-row>
                        <b-row class="pt-4">
                            <b-col cols="2" class="text-title">Bengkak</b-col>
                            <b-col cols="3">: {{ fieldOdonPemeriksaan.bengkak || '-' }}</b-col>
                            <b-col cols="2" class="text-title offset-1">Suhu Kulit</b-col>
                            <b-col cols="3">: {{ fieldOdonPemeriksaan.suhu_kulit || '-' }}</b-col>
                        </b-row>
                        <b-row class="pt-4">
                            <b-col cols="2" class="text-title">Konsistensi</b-col>
                            <b-col cols="3">: {{ fieldOdonPemeriksaan.konsistensi || '-' }}</b-col>
                        </b-row>
                        <label for="kondisi-gigi" class="text-title mt-5">Pemeriksaan Intraoral</label>
                        <b-row class="pt-3">
                            <b-col cols="2" class="text-title">Goyang</b-col>
                            <b-col cols="3">: {{ fieldOdonPemeriksaan.goyang || '-' }}</b-col>
                            <b-col cols="2" class="text-title offset-1">Perkusi</b-col>
                            <b-col cols="3">: {{ fieldOdonPemeriksaan.perkusi || '-' }}</b-col>
                        </b-row>
                        <b-row class="pt-4">
                            <b-col cols="2" class="text-title">Warna Gusi</b-col>
                            <b-col cols="3">: {{ fieldOdonPemeriksaan.warna_gusi || '-' }}</b-col>
                            <b-col cols="2" class="text-title offset-1">Druk</b-col>
                            <b-col cols="3">: {{ fieldOdonPemeriksaan.druk || '-' }}</b-col>
                        </b-row>
                        <b-row class="pt-4">
                            <b-col cols="2" class="text-title">Karies Gigi</b-col>
                            <b-col cols="3">: {{ fieldOdonPemeriksaan.karies_gigi || '-' }}</b-col>
                            <b-col cols="2" class="text-title offset-1">Palpasi</b-col>
                            <b-col cols="3">: {{ fieldOdonPemeriksaan.palpasi || '-' }}</b-col>
                        </b-row>
                        <b-row class="pt-4">
                            <b-col cols="2" class="text-title">Pembengkakan</b-col>
                            <b-col cols="3">: {{ fieldOdonPemeriksaan.pembengkakan || '-' }}</b-col>
                            <b-col cols="2" class="text-title offset-1">Status Karies</b-col>
                            <b-col cols="3">: {{ fieldOdonPemeriksaan.status_karies || '-' }}</b-col>
                        </b-row>
                    </b-col>

                    <b-col lg="12" md="12" class="text-center mt-5">
                        <b-img v-bind:src="drawPathGigi"></b-img>
                    </b-col>
                    <b-col lg="12" md="12" :style="`width: ${contentWidth}px;`">
                        <label for="kondisi-gigi" class="text-title">Catatan:</label>
                        <div v-html="checkValueData(dataRM.odontogram.notes) ? dataRM.odontogram.notes : '-'"></div>
                    </b-col>
                </b-row>

                <div class="row mt-4">
                    <div class="col-md-12 media">
                        <div class="media-body">
                            <label for="kondisi-gigi" class="text-title">Kondisi Gigi</label>
                        </div>
                    </div>
                    <div class="col-md-12 table-responsive mt-3">
                        <b-table
                            :fixed="true"
                            :items="listConditionGigi"
                            :fields="fieldListGigi"
                            :borderless="true"
                            class="custom_border"
                        >
                            <template v-slot:cell()="data">
                                <p v-if="data.item.is_blank">&nbsp;</p>
                                <p v-else>{{ checkValueData(data.value) ? data.value : '-' }}</p>
                            </template>
                            <template v-slot:cell(icdx)="data">
                                <p v-for="(v, i) in data.item.icdx" :key="i">{{ checkValueData(v) ? v : '-' }}</p>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
        </div>

        <div class="card card-box mb-3" v-if="poliGigi">
            <div class="card-body p-4">
                <div class="row">
                    <div class="col-md-5">
                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Occlusi</div>
                            <div class="col-md-6">{{ dataRM.odontogram.occlusi || '-' }}</div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Torus Palatinus</div>
                            <div class="col-md-6">{{ dataRM.odontogram.torus_palatinus || '-' }}</div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Torus Mandibularis</div>
                            <div class="col-md-6">{{ dataRM.odontogram.torus_mandibularis || '-' }}</div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Palatum</div>
                            <div class="col-md-6">{{ dataRM.odontogram.palatum || '-' }}</div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Diastema</div>
                            <div class="col-md-6">{{ convertDataGigi(dataRM.odontogram.diastema, dataRM.odontogram.ket_diastema, ',') }}</div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Jumlah photo yang diambil</div>
                            <div class="col-md-6">{{ convertDataGigi(dataRM.odontogram.qty_photo, dataRM.odontogram.satuan_photo) }}</div>
                        </div>
                    </div>
                    <div class="col-md-7">
                        <div class="row mb-4">
                            <div class="col-md-5 text-title">Gigi Anomali</div>
                            <div class="col-md-7">{{ convertDataGigi(dataRM.odontogram.gigi_anomali, dataRM.odontogram.ket_gigi_anomali, ',') }}</div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-md-5 text-title">Lain - Lain</div>
                            <div class="col-md-7">{{ dataRM.odontogram.lain_lain || '-' }}</div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-md-5 text-title">Decay</div>
                            <div class="col-md-7">{{ dataRM.odontogram.d || '-' }}</div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-md-5 text-title">Missing</div>
                            <div class="col-md-7">{{ dataRM.odontogram.m || '-' }}</div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-md-5 text-title">Filling</div>
                            <div class="col-md-7">{{ dataRM.odontogram.f || '-' }}</div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-md-5 text-title">Jumlah rontgen photo yang diambil</div>
                            <div class="col-md-7">{{ convertDataGigi(dataRM.odontogram.qty_rontgen, dataRM.odontogram.satuan_rontgen) }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card card-box mb-3" v-if="poliGigi">
            <div class="card-body p-4">
                <b-row>
                    <b-col cols="12" class="media">
                        <div class="media-body">
                            <label for="ohis" class="text-title">Index Kebersihan Gigi dan Mulut (OHIS)</label>
                        </div>
                    </b-col>
                    <b-col cols="5">
                        <label class="pr-0 label_select col-form-label text-title">
                            Debris Index (DI)
                        </label>
                        <b-row class="ml-1">
                            <b-col cols="4" class="text-center pl-0">
                                <label class="pr-0 label_select col-form-label text-title">16</label>
                                <br />
                                <b-form-input
                                    ref="debris_index_16"
                                    type="text" class="text-center text-title"
                                    v-model.lazy="formOdonOHIS.debris_index_16"
                                    readonly
                                />
                            </b-col>
                            <b-col cols="4" class="text-center pl-0">
                                <label class="pr-0 label_select col-form-label text-title">11</label>
                                <br />
                                <b-form-input
                                    ref="debris_index_11"
                                    type="text" class="text-center text-title"
                                    v-model.lazy="formOdonOHIS.debris_index_11"
                                    readonly
                                />
                            </b-col>
                            <b-col cols="4" class="text-center pl-0">
                                <label class="pr-0 label_select col-form-label text-title">26</label>
                                <br />
                                <b-form-input
                                    ref="debris_index_26"
                                    type="text" class="text-center text-title"
                                    v-model.lazy="formOdonOHIS.debris_index_26"
                                    readonly
                                />
                            </b-col>
                            <b-col cols="4" class="text-center pl-0">
                                <label class="pr-0 label_select col-form-label text-title">36</label>
                                <br />
                                <b-form-input
                                    ref="debris_index_36"
                                    type="text" class="text-center text-title"
                                    v-model.lazy="formOdonOHIS.debris_index_36"
                                    readonly
                                />
                            </b-col>
                            <b-col cols="4" class="text-center pl-0">
                                <label class="pr-0 label_select col-form-label text-title">31</label>
                                <br />
                                <b-form-input
                                    ref="debris_index_31"
                                    type="text" class="text-center text-title"
                                    v-model.lazy="formOdonOHIS.debris_index_31"
                                    readonly
                                />
                            </b-col>
                            <b-col cols="4" class="text-center pl-0">
                                <label class="pr-0 label_select col-form-label text-title">46</label>
                                <br />
                                <b-form-input
                                    ref="debris_index_46"
                                    type="text" class="text-center text-title"
                                    v-model.lazy="formOdonOHIS.debris_index_46"
                                    readonly
                                />
                            </b-col>
                        </b-row>
                        <label class="pr-0 label_select col-form-label text-title text-title mt-3">
                            Total Skor Debris Index (DI)
                        </label>
                        <div v-if="checkTotalOhis(formOdonOHIS.total_debris_index)" for="total_debris_index" class="text-title">
                            {{ formOdonOHIS.subtotal_debris_index }}
                            <span v-html="icon.division"></span>
                            {{ formOdonOHIS.count_debris_index }}
                            <span class="text-title" v-html="icon.equals"></span>
                            {{ formatNumber(formOdonOHIS.total_debris_index) }}
                        </div>
                        <div v-else for="total_debris_index" class="text-title">-</div>
                        <label class="pr-0 label_select col-form-label text-title mt-3 text-title">
                            Skor Total OHIS= DI + CI =
                        </label>
                        <div v-if="checkTotalOhis(formOdonOHIS.total_ohis)" for="total_ohis" class="text-title">
                            {{ formatNumber(formOdonOHIS.total_debris_index) }}
                            <span class="text-title" v-html="icon.plus"></span>
                            {{ formatNumber(formOdonOHIS.total_kalkulus_index) }}
                            <span class="text-title" v-html="icon.equals"></span>
                            {{ formatNumber(formOdonOHIS.total_ohis) }}
                        </div>
                        <div v-else for="total_ohis" class="text-title">-</div>
                    </b-col>
                    <b-col cols="5" class="offset-1">
                        <label class="pr-0 label_select col-form-label text-title text-title">
                        Kalkulus Index (CI)
                        </label>
                        <b-row class="ml-1">
                            <b-col cols="4" class="text-center pl-0">
                                <label class="pr-0 label_select col-form-label text-title">16</label>
                                <br />
                                <b-form-input
                                    ref="kalkulus_index_16"
                                    type="text" class="text-center text-title"
                                    v-model.lazy="formOdonOHIS.kalkulus_index_16"
                                    readonly
                                />
                            </b-col>
                            <b-col cols="4" class="text-center pl-0">
                                <label class="pr-0 label_select col-form-label text-title">11</label>
                                <br />
                                <b-form-input
                                    ref="kalkulus_index_11"
                                    type="text" class="text-center text-title"
                                    v-model.lazy="formOdonOHIS.kalkulus_index_11"
                                    readonly
                                />
                            </b-col>
                            <b-col cols="4" class="text-center pl-0">
                                <label class="pr-0 label_select col-form-label text-title">26</label>
                                <br />
                                <b-form-input
                                    ref="kalkulus_index_26"
                                    type="text" class="text-center text-title"
                                    v-model.lazy="formOdonOHIS.kalkulus_index_26"
                                    readonly
                                />
                            </b-col>
                            <b-col cols="4" class="text-center pl-0">
                                <label class="pr-0 label_select col-form-label text-title">36</label>
                                <br />
                                <b-form-input
                                    ref="kalkulus_index_36"
                                    type="text" class="text-center text-title"
                                    v-model.lazy="formOdonOHIS.kalkulus_index_36"
                                    readonly
                                />
                            </b-col>
                            <b-col cols="4" class="text-center pl-0">
                                <label class="pr-0 label_select col-form-label text-title">31</label>
                                <br />
                                <b-form-input
                                    ref="kalkulus_index_31"
                                    type="text" class="text-center text-title"
                                    v-model.lazy="formOdonOHIS.kalkulus_index_31"
                                    readonly
                                />
                            </b-col>
                            <b-col cols="4" class="text-center pl-0">
                                <label class="pr-0 label_select col-form-label text-title">46</label>
                                <br />
                                <b-form-input
                                    ref="kalkulus_index_46"
                                    type="text" class="text-center text-title"
                                    v-model.lazy="formOdonOHIS.kalkulus_index_46"
                                    readonly
                                />
                            </b-col>
                        </b-row>
                        <label class="pr-0 label_select col-form-label text-title mt-3">
                            Total Skor Kalkulus Index (CI)
                        </label>
                        <div v-if="checkTotalOhis(formOdonOHIS.total_kalkulus_index)" for="total_kalkulus_index" class="text-title">
                            {{ formOdonOHIS.subtotal_kalkulus_index }}
                            <span class="text-title" v-html="icon.division"></span>
                            {{ formOdonOHIS.count_kalkulus_index }}
                            <span class="text-title" v-html="icon.equals"></span>
                            {{ formatNumber(formOdonOHIS.total_kalkulus_index) }}
                        </div>
                        <div v-else for="total_kalkulus_index" class="text-title">-</div>
                    </b-col>
                </b-row>
            </div>
        </div>

        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <div class="row">
                    <div class="col-md-4">
                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Luas Permukaan Tubuh Untuk Anak-Anak</div>
                            <div class="col-md-6">{{ dataRM.pemeriksaan_fisik.luas_fisik || '-' }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Kepala</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.kepala, dataRM.pemeriksaan_fisik.ket_kepala) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Mata</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.mata, dataRM.pemeriksaan_fisik.ket_mata) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Telinga</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.telinga, dataRM.pemeriksaan_fisik.ket_telinga) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Hidung</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.hidung, dataRM.pemeriksaan_fisik.ket_hidung) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Rambut</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.rambut, dataRM.pemeriksaan_fisik.ket_rambut) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Bibir</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.bibir, dataRM.pemeriksaan_fisik.ket_bibir) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Gigi Geligi</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.gigi_geligi, dataRM.pemeriksaan_fisik.ket_gigi_geligi) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Lidah</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.lidah, dataRM.pemeriksaan_fisik.ket_lidah) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Langit-Langit</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.langit_langit, dataRM.pemeriksaan_fisik.ket_langit_langit) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Leher</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.leher, dataRM.pemeriksaan_fisik.ket_leher) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Tenggorokan</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.tenggorokan, dataRM.pemeriksaan_fisik.ket_tenggorokan) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Tonsil</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.tonsil, dataRM.pemeriksaan_fisik.ket_tonsil) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Dada</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.dada, dataRM.pemeriksaan_fisik.ket_dada) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Payudara</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.payudara, dataRM.pemeriksaan_fisik.ket_payudara) }}</div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Punggung</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.punggung, dataRM.pemeriksaan_fisik.ket_punggung) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Perut</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.perut, dataRM.pemeriksaan_fisik.ket_perut) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Genital</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.genital, dataRM.pemeriksaan_fisik.ket_genital) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Anus/Dubur</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.anus, dataRM.pemeriksaan_fisik.ket_anus) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Lengan Atas</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.lengan_atas, dataRM.pemeriksaan_fisik.ket_lengan_atas) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Lengan Bawah</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.lengan_bawah, dataRM.pemeriksaan_fisik.ket_lengan_bawah) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Jari Tangan</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.jari_tangan, dataRM.pemeriksaan_fisik.ket_jari_tangan) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Kuku Tangan</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.kuku_tangan, dataRM.pemeriksaan_fisik.ket_kuku_tangan) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Persendian Tangan</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.persendian_tangan, dataRM.pemeriksaan_fisik.ket_persendian_tangan) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Tungkai Atas</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.tungkai_atas, dataRM.pemeriksaan_fisik.ket_tungkai_atas) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Tungkai Bawah</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.tungkai_bawah, dataRM.pemeriksaan_fisik.ket_tungkai_bawah) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Jari Kaki</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.jari_kaki, dataRM.pemeriksaan_fisik.ket_jari_kaki) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Kuku Kaki</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.kuku_kaki, dataRM.pemeriksaan_fisik.ket_kuku_kaki) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Persendian Kaki</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.persendian_kaki, dataRM.pemeriksaan_fisik.ket_persendian_kaki) }}</div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Status Psikologis</div>
                            <div class="col-md-6">{{ getStatusPsikologis(dataRM.pemeriksaan_fisik.status_psikologis) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Sosial Ekonomi</div>
                            <div class="col-md-6">{{ dataRM.pemeriksaan_fisik.sosial_ekonomi || '-' }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 text-title">Spiritual</div>
                            <div class="col-md-6">{{ dataRM.pemeriksaan_fisik.spiritual || '-' }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <b-row>
                    <b-col md="12" lg="12">
                      <h5 class="text-header">Pemeriksaan Penunjang</h5>
                    </b-col>
                    <b-col md="12" lg="12" v-for="pph in dataPemeriksaanPenunjang" :key="pph.master_pemeriksaan_penunjang_id">
                        <b-row>
                          <b-col sm="4" class="py-2">Kategori Pemeriksaan Penunjang</b-col>
                          <b-col sm="8" class="text-subtitle py-2">
                            {{pph.master && pph.master.category}}
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col sm="4" class="py-2">Jenis Pemeriksaan Penunjang</b-col>
                          <b-col sm="8" class="text-subtitle py-2">
                            {{pph.master && pph.master.name}}
                          </b-col>
                        </b-row>
                        <b-row v-if="pph.master && pph.master.name.includes('Lainnya')">
                          <b-col sm="4" class="py-2">Nama Pemeriksaan Penunjang</b-col>
                          <b-col sm="8" class="text-subtitle py-2">
                            {{pph.nama}}
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col sm="4" class="py-2">Tanggal Pemeriksaan</b-col>
                          <b-col sm="8" class="text-subtitle py-2">
                            {{formatDate(pph.tanggal,'DD/MM/YYYY')}}
                          </b-col>
                        </b-row>
                        <b-row v-if="pph.file && pph.file.length > 0">
                          <b-col sm="4" class="py-2">Unggahan Hasil Pemeriksaan</b-col>
                          <b-col sm="8" class="text-subtitle py-2">
                            <div class="media" v-for="f in pph.file" :key="f.id">
                                <div class="media-left">{{ f.name }}</div>
                                <div class="media-body ml-4">
                                    <font-awesome-icon class="align-middle icon-file"
                                        @click="downloadImage(f, 'download')" icon="download" />
                                    <font-awesome-icon class="align-middle icon-file"
                                        @click.prevent="downloadImage(f, 'preview')" icon="eye" />
                                </div>
                            </div>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col sm="4" class="py-2">Hasil Pemeriksaan</b-col>
                          <b-col sm="8" class="text-subtitle py-2">
                            {{pph.hasil}}
                          </b-col>
                        </b-row>
                        <hr/>
                    </b-col>
                    <b-col md="12" lg="12" v-for="items in dataMCU" :key="items.id">
                        <b-row>
                          <b-col sm="4" class="text-title">Jenis Pemeriksaan Penunjang</b-col>
                          <b-col sm="8" class="text-subtitle" v-if="items.selectedJenis && items.selectedJenis.value == 'pemeriksaanLain'">
                            {{items.jenis_lain}}
                          </b-col>
                          <b-col sm="8" class="text-subtitle" v-else>
                            {{items.selectedJenis && items.selectedJenis.label}}
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col sm="4" class="text-title">Hasil</b-col>
                          <b-col sm="8">
                            <template v-if="items.selectedJenis && items.selectedJenis.value == 'radiologiFoto'">
                                <img :src="items.hasil.url" class="img-fluid" alt="img" />
                            </template>
                            <template v-else>
                                {{items.hasil}}
                            </template>
                          </b-col>
                        </b-row>
                        <hr/>
                    </b-col>
                    <b-col md="12" lg="12">
                        <h6 class="mt-3 text-title">Uploaded file:</h6>
                        <div>
                            <template v-if="datafile.length > 0">
                                <b-row v-for="items in datafile" :key="items.id">
                                  <b-col sm="4">{{ items.name }}</b-col>
                                  <b-col sm="8">
                                    <font-awesome-icon class="align-middle icon-file"
                                        @click="downloadImage(items, 'download')" icon="download" />
                                    <font-awesome-icon class="align-middle icon-file"
                                        @click.prevent="downloadImage(items, 'preview')" icon="eye" />
                                  </b-col>
                                </b-row>
                            </template>
                            <template v-else>
                                <span>-</span>
                            </template>
                        </div>
                    </b-col>
                    <b-col md="12" lg="12" :style="`width: ${contentWidth}px;`">
                        <label for="Keterangan" class="text-title">Keterangan:</label>
                        <div v-html="dataRM.pemeriksaan_penunjang.notes"></div>
                    </b-col>
                    <b-col md="12" lg="12">
                        <template v-if="checkValueData(dataRM.pemeriksaan_penunjang.draw_path)">
                            <img :src="dataRM.pemeriksaan_penunjang.draw_path" class="img-fluid" alt="img" />
                        </template>
                    </b-col>
                </b-row>
            </div>
        </div>

        <b-modal size="xl" ref="show-penunjang-doc" class="modal-backdrop" hide-footer scrollable title="Preview Dokumen">
            <div class="d-block text-center" style="height: 100%">
                <img :src="previewFile" class="img-fluid"
                    v-show="/jpg|jpeg|jfif|pjpeg|pjp|png|svg|webp|giff/.test(previewFile)" alt="preview-document">
                <iframe :src="previewFile" v-show="/pdf/.test(previewFile)" frameBorder="0" height="100%" width="100%"></iframe>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import moment from 'moment';
    import { mapGetters, mapState } from "vuex";
    import rekamMedisMixin from "../mixins";
    import { library } from "@fortawesome/fontawesome-svg-core";
    import { faFile, faDownload, faEye } from "@fortawesome/free-solid-svg-icons";
    
    library.add(faFile, faDownload, faEye);

    export default {
        name: "Objective",
        mixins: [rekamMedisMixin],
        props: ["dataRM", "poliGigi"],
        data() {
            return {
                drawPathGigi: null,
                listConditionGigi: [
                {
                    id: null,
                    no_gigi: null,
                    bagian: null,
                    kondisi: null,
                    icd_x: [],
                    keterangan: null,
                    is_blank: true,
                }
                ],
                permukaanGigi: [
                    { value: 'all', label: 'Semua' },
                    { value: 'M', label: 'M - Messial' },
                    { value: 'O', label: 'O - Occlusal' },
                    { value: 'D', label: 'D - Distal' },
                    { value: 'V', label: 'V - Vestibular/Bukal/Labial' },
                    { value: 'L', label: 'L - Lingual/Palatal' },
                ],
                drawPathFisik: null,
                kategoriPasien: null,
                kodeSadar: [
                    {
                        kdSadar: "01",
                        nmSadar: "Compos mentis"
                    },
                    {
                        kdSadar: "02",
                        nmSadar: "Somnolence"
                    },
                    {
                        kdSadar: "03",
                        nmSadar: "Sopor"
                    },
                    {
                        kdSadar: "04",
                        nmSadar: "Coma"
                    }
                ],
                kesadaran: null,
                datafile: [],
                previewFile: null,
                dataPemeriksaanPenunjang: [],
                dataMCU: [],
                contentWidth: 1100,
                contentHalfWidth: 675,
                fieldOdonPemeriksaan: {
                    muka: null,
                    warna_kulit: null,
                    bengkak: null,
                    suhu_kulit: null,
                    konsistensi: null,
                    goyang: null,
                    perkusi: null,
                    warna_gusi: null,
                    druk: null,
                    karies_gigi: null,
                    palpasi: null,
                    pembengkakan: null,
                    status_karies: null,
                },
                formOdonOHIS: {
                    debris_index_16: null,
                    debris_index_11: null,
                    debris_index_26: null,
                    debris_index_36: null,
                    debris_index_31: null,
                    debris_index_46: null,
                    subtotal_debris_index: null,
                    count_debris_index: null,
                    total_debris_index: null,
                    kalkulus_index_16: null,
                    kalkulus_index_11: null,
                    kalkulus_index_26: null,
                    kalkulus_index_36: null,
                    kalkulus_index_31: null,
                    kalkulus_index_46: null,
                    subtotal_kalkulus_index: null,
                    count_kalkulus_index: null,
                    total_kalkulus_index: null,
                    total_ohis: null,
                },
                icon: {
                    division: `
                        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 20 20" fill="none">
                        <path d="M5 11C4.44772 11 4 10.5523 4 10C4 9.44772 4.44772 9 5 9H15C15.5523 9 16 9.44772 16 10C16 10.5523 15.5523 11 15 11H5Z" fill="#000000"/>
                        <circle cx="10" cy="5.5" r="1.5" fill="#000000"/>
                        <circle cx="10" cy="14.5" r="1.5" fill="#000000"/>
                        </svg>
                    `,
                    plus: '+',
                    equals: '=',
                },
            }
        },
        computed: {
            ...mapState(['sidebar']),
            ...mapGetters('sidebar', ['collapsed']),
            ...mapGetters(["getKlinikId"]),
            fieldListGigi() {
                return (
                    [
                        {
                            key: 'no_gigi',
                            label: 'no gigi',
                            thClass: 'head-custom',
                            stickyColumn: true,
                            isRowHeader: true,
                        },
                        {
                            key: 'bagian',
                            label: 'bagian',
                            thClass: 'head-custom',
                        },
                        {
                            key: 'kondisi',
                            label: 'kondisi',
                            thClass: 'head-custom',
                        },
                        {
                            key: 'icdx',
                            label: 'icd 10',
                            thClass: 'head-custom',
                        },
                        {
                            key: 'keterangan',
                            label: 'keterangan tambahan',
                            thClass: 'head-custom',
                        },
                    ]
                )
            },
        },
        watch: {
            dataRM() {
                this.buildData();
            },
            collapsed() {
                this.resizeWidth(window.innerWidth, this.collapsed);
            },
        },
        mounted() {
            this.resizeWidth(window.innerWidth, this.collapsed);
            this.buildData();
        },
        methods: {
            resizeWidth(w, collapsed = false) {
                let zoom = w / 19.2;

                let x = 1.415;
                if (collapsed) {
                    if (zoom < 100) x = 1.325;
                    else x = 1.2;
                } else if (zoom < 100) x = 1.7;

                this.contentWidth = w / x;

                // half
                let h = 2.845;
                if (collapsed) {
                if (zoom < 100) h = 2.725;
                else h = 2.478;
                } else if (zoom < 100) h = 3.35;

                this.contentHalfWidth = w / h;
            },
            buildData() {
                if (this.dataRM) {
                    if (this.poliGigi) {
                        if (this.checkValueData(this.dataRM.odontogram) && this.checkValueData(this.dataRM.odontogram.draw_path)) this.drawPathGigi = this.dataRM.odontogram.draw_path;
                        else this.drawPathGigi = 'https://fs.izidok.id/izidok/odontogram/odontogram-20240313120342-115619585.png';

                        if (this.dataRM.odontogram_table) {
                            this.listConditionGigi = this.dataRM.odontogram_table.map(d => {
                                let pg = this.permukaanGigi.find(pg => pg.value == d.permukaan_gigi);
                                return {
                                    ...d,
                                    bagian: pg ? pg.label : '-',
                                    kondisi: this.setKondisi(d),
                                    icdx: d.icd_x.length > 0 ? d.icd_x.map(icd => `${icd.kode} - ${icd.description}`): '-',
                                    is_blank: false,
                                }
                            });
                        }

                        if (this.checkValueData(this.dataRM.odontogram)) {
                            Object.keys(this.fieldOdonPemeriksaan).forEach(f => {
                                if (this.dataRM.odontogram.hasOwnProperty(f)) {
                                    let val = this.dataRM.odontogram[f];
                                    this.fieldOdonPemeriksaan[f] = this.checkValueData(val) ? val : '-';
                                }
                            });
                    
                            if (this.checkValueData(this.dataRM.odontogram.ohis)) {
                                Object.keys(this.formOdonOHIS).forEach(f => {
                                    if (this.dataRM.odontogram.ohis.hasOwnProperty(f)) {
                                        let val = this.dataRM.odontogram.ohis[f];
                                        this.formOdonOHIS[f] = val != null && val != undefined ? val : '-';
                                    }
                                });
                            }
                        }
                    }

                    this.datafile = []
                    this.dataMCU = []
                    if (this.dataRM.bpjs_mcu && this.dataRM.bpjs_mcu.data && this.dataRM.bpjs_mcu.data.length > 0) {
                      this.dataMCU = this.dataRM.bpjs_mcu.data
                      let radiologi = this.dataRM.bpjs_mcu.data.find(item => item.selectedJenis && item.selectedJenis.value == 'radiologiFoto')
                      if (radiologi) {
                        this.datafile.push(radiologi.hasil)
                      }
                    }
                    this.dataPemeriksaanPenunjang = [];
                    if (this.dataRM.pemeriksaan_penunjang_hasil && this.dataRM.pemeriksaan_penunjang_hasil && this.dataRM.pemeriksaan_penunjang_hasil.length > 0) {
                      this.dataPemeriksaanPenunjang = this.dataRM.pemeriksaan_penunjang_hasil;
                      let radio = this.dataRM.pemeriksaan_penunjang_hasil.find(item => item.selectedJenis && item.selectedJenis.label.includes('Radiologi'))
                      if (radio) {
                        this.datafile.push(radio.file)
                      }
                    }

                    if (this.dataRM.pemeriksaan_penunjang && this.dataRM.pemeriksaan_penunjang.files !== 'null') {
                      this.datafile = this.datafile.concat(JSON.parse(this.dataRM.pemeriksaan_penunjang.files));
                    }

                    this.kategoriPasien = this.dataRM.transklinik.kategori_id
                    this.drawPathFisik = this.dataRM.pemeriksaan_fisik.is_draw == 1 && this.dataRM.pemeriksaan_fisik.draw_path ? this.dataRM.pemeriksaan_fisik.draw_path : null;

                    if (this.kategoriPasien == 2) {
                        this.kesadaran = this.kodeSadar.find((({ kdSadar }) => kdSadar == this.dataRM.bpjs_kdSadar))
                    }
                }
            },
            setKondisi(data) {
                let kondisi = [];
                if (data.keadaan_gigi.length > 0) kondisi = [...kondisi, ...data.keadaan_gigi];
                if (data.bahan_restorasi.length > 0) kondisi = [...kondisi, ...data.bahan_restorasi];
                if (data.restorasi.length > 0) kondisi = [...kondisi, ...data.restorasi];
                if (data.protesa.length > 0) kondisi = [...kondisi, ...data.protesa];
                return kondisi.length > 0 ? kondisi.join(' - ') : '-';
            },
            getStatusPsikologis(status) {
                const statusMapping = {
                    N: "Tidak Ada Kelainan",
                    C: "Cemas",
                    T: "Takut",
                    M: "Marah",
                    S: "Sedih",
                    L: `Lain-Lain, ${this.dataRM.pemeriksaan_fisik.ket_status_psikologis}` 
                };

                return statusMapping[status] || "-";
            },
            convertData(status, content){
                if(status == 'T'){
                    return 'Tidak Ada Kelainan'
                }

                if(status == 'Y'){
                    return `Ada Kelainan, ${content}`
                }

                if(status == 'N'){
                    return `Tidak Diperiksa`
                }
                return '-'
            },
            convertDataGigi(val, ket, coma = '') {
                let result = '';
                if (this.checkValueData(val)) {
                    result += val;
                    if (this.checkValueData(ket)) result += `${coma} ${ket}`;
                } else {
                    result = '-';
                }
                return result;
            },
            async downloadImage(item, type) {
                if (type == 'download') {
                    let fileName = this.getPureName(item);
                    const result = await this.toDataURL(item.url);

                    if (result && result.fallback) {
                        const a = document.createElement('a');
                        a.href = result.url;
                        a.download = Object.values(fileName).join('.');
                        a.target = '_blank';
                        a.rel = 'noopener';
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                    } else {
                        const a = document.createElement('a');
                        a.href = result;
                        a.download = Object.values(fileName).join('.');
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                    }
                } else {
                    if (/pdf/.test(item.url) && (this.isMobile() || this.isMobileTab())) {
                        const link = document.createElement('a');
                        link.href = item.url;
                        link.target = '_blank';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setTimeout(() => URL.revokeObjectURL(item.url), 1000);
                        return;
                    }
                    
                    this.previewFile = item.url;
                    this.$refs['show-penunjang-doc'].show();
                }
            },
            getPureName(raw) {
                let names = raw.name.split('.');
                if (names.length < 2) names.push(raw.url.split('.').pop());

                return {
                    name: names[0].replace(/[-_]/g, ' '),
                    ext: names[1]
                }
            },
            async toDataURL(url) {
                try {
                    const res = await fetch(url);
                    if (!res.ok) throw new Error("Failed to fetch");

                    const blob = await res.blob();
                    return URL.createObjectURL(blob);
                } catch (err) {
                    return { fallback: true, url };
                }
            },
            formatNumber(value) {
                return value && value != '-' ? new Intl.NumberFormat('id-ID').format(value) : value;
            },
            checkTotalOhis(value) {
                let val = parseInt(value);
                if (!isNaN(val) && val) return true;
                return false
            },
            formatDate(date, format = 'DD-MM-YYYY') {
                return moment(date).format(format);
            },
        }
    }
</script>

<style>
    .mb-header {
        margin-bottom: -15px;
    }
    .custom_border {
        border: 2px solid #eee;
        border-radius: 5px;
    }
    .custom_border td, .custom_border th {
        vertical-align: top;
    }
    .icon-file {
        color: #3b3e66;
        padding: 5px;
        font-size: 2em;
        cursor: pointer;
    }
</style>
